import { render, staticRenderFns } from "./RNDNotification.vue?vue&type=template&id=220f1a57&"
import script from "./RNDNotification.vue?vue&type=script&lang=js&"
export * from "./RNDNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports